if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    
    }

        onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton || submitButton.classList.contains('loading')) {
        return;
      }

      this.handleErrorMessage();

      const petNameInput = this.form.querySelector(
        '[data-required-pet-name]'
      );

      if (petNameInput) {
        petNameInput.value = petNameInput.value.trim();

        if (!petNameInput.value) {
          this.handleErrorMessage('Please enter your pet’s name.');
          petNameInput.focus();
          return;
        }
      }

      const formData = new FormData(this.form);

      if (petNameInput) {
        const prescriptionValues = formData.getAll(
          'properties[Prescription]'
        );

        const hasPrescription = prescriptionValues.some((value) => {
          return typeof value === 'string' && value.trim().length > 0;
        });

        if (!hasPrescription) {
          this.handleErrorMessage(
            'Please upload your prescription and wait for it to finish.'
          );
          return;
        }
      }

      if (submitButton.disabled) return;

      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      formData.append(
        'sections',
        this.cartNotification.getSectionsToRender()
          .map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
          this.handleErrorMessage(
            'Unable to add this item. Please check your cart before trying again.'
          );
        })
        .finally(() => {
          $.getJSON('/cart.js', function(data) {
            $('.cart_current_qty').text(data.item_count);
          });

          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(
          '.product-form__error-message'
        );

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
